import { getApi, getPaginated } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';
import { Filter } from 'util/backendapi/models/api.interfaces';

export const timeLagMonitorListDuck = makeReportingDuck(
  'timeLagMonitor',
  (filters: Filter.ReportsTimeLagMonitor) =>
    getPaginated('/reports/time-lag-monitors/', filters),
  () => getApi('/reports/time-lag-monitors/info/')
);

export type TimeLagMonitorListActions = ReportingDuckActions<
  typeof timeLagMonitorListDuck
>;
